export const PARTIAL_CATEGORY_FIXTURE = [
    {
        display_name: 'Film, Media & Entertainment',
        url: 'https://www.eventbrite.com/d/ny--new-york/film-and-media--events/',
        tag: 'EventbriteCategory/104',
        id: '104',
    },
    {
        display_name: 'Music',
        url: 'https://www.eventbrite.com/d/ny--new-york/music--events/',
        tag: 'EventbriteCategory/103',
        id: '103',
    },
    {
        display_name: 'Performing & Visual Arts',
        url: 'https://www.eventbrite.com/d/ny--new-york/arts--events/',
        tag: 'EventbriteCategory/105',
        id: '105',
    },
    {
        display_name: 'Fashion',
        url: 'https://www.eventbrite.com/d/ny--new-york/fashion--events/',
        tag: 'EventbriteCategory/106',
        id: '106',
    },
    {
        display_name: 'Fashion',
        url: 'https://www.eventbrite.com/d/ny--new-york/fashion--events/',
        tag: 'EventbriteCategory/107',
        id: '107',
    },
    {
        display_name: 'Hobbies & Special Interest',
        url: 'https://www.eventbrite.com/d/ny--new-york/hobbies--events/',
        tag: 'EventbriteCategory/119',
        id: '119',
    },
    {
        display_name: 'Audio & Visual',
        url: 'https://www.eventbrite.com/d/ny--new-york/audio-visual--events/',
        tag: 'EventbriteCategory/110',
        id: '110',
    },
    {
        display_name: 'Sports & Fitness',
        url: 'https://www.eventbrite.com/d/ny--new-york/sports-and-fitness--events/',
        tag: 'EventbriteCategory/108',
        id: '108',
    },
    {
        display_name: 'Sports & Fitness',
        url: 'https://www.eventbrite.com/d/ny--new-york/sports-and-fitness--events/',
        tag: 'EventbriteCategory/108',
        id: '108',
    },
];
